var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlertaAproximacin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.23 110.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7551bc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-alerta-aproximaci\xF3n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_13",
    "data-name": 13
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.1,87.68a.62.62,0,0,0,.62.31h39.64a1.84,1.84,0,0,1,1.33.55,1.8,1.8,0,0,1,.54,1.32V108.2a1.84,1.84,0,0,1-1.87,1.87H73.45a1.86,1.86,0,0,1-1.87-1.87V91a3.16,3.16,0,0,1,.94-2.33q9.33-8.72,24.72-25l9.32-9.8q14.14-14.61,14.15-21.3A9.53,9.53,0,0,0,117.37,25a12.56,12.56,0,0,0-8.63-3,12.26,12.26,0,0,0-8.55,3,10,10,0,0,0-3.26,7.77v3.73a1.84,1.84,0,0,1-.55,1.33,1.8,1.8,0,0,1-1.32.54H72.67a1.8,1.8,0,0,1-1.32-.54,1.83,1.83,0,0,1-.54-1.33V28.76a27.16,27.16,0,0,1,5.75-15.23,32.85,32.85,0,0,1,13.52-10A48.13,48.13,0,0,1,108.74,0a44.8,44.8,0,0,1,20.13,4.28,31.8,31.8,0,0,1,13.22,11.58,29.71,29.71,0,0,1,1.48,29.07,65.45,65.45,0,0,1-9.33,13.84q-4.37,5.28-9.8,10.72T109.36,84.11l-3.11,3A.49.49,0,0,0,106.1,87.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.78 33.61 51.81 24.64 30.39 46.07 8.97 24.64 0 33.61 21.42 55.03 0 76.46 8.97 85.42 30.39 64 51.81 85.42 60.78 76.46 39.36 55.03 60.78 33.61"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertaAproximacin);
export default __webpack_public_path__ + "static/media/ic-alerta-aproximación.efed8029a791a1baffcb9c5792c6342d.svg";
export { ForwardRef as ReactComponent };